export interface Environment {
  name: string;
  production: boolean;
  backendHost: string;
  auditAppURL: string;
  sentryDSN: string;
  googleSignin: boolean;
  microsoftSignin: boolean;
  googleClientId: string;
  showEmailPasswordSignin: boolean;
  logo: string;
}

export const environment: Environment = {
  // Values are loaded from `config.js` script included in `index.html`
  ...(<any>window).config,
};
